import {Alert} from '@hm/fundamental'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {PinValidationBanner} from './PinValidationBanner'

/**
 * Props for the Confirmation Banner component using discriminated union.
 * Each mode enforces the required props for that specific state.
 */
export type ConfirmationBannerProps =
  | {mode: 'disabled'; message: string}
  | {mode: 'pin-required'}
  | {mode: 'warning'}
  | {mode: 'none'}

/**
 * Banner component that renders the appropriate banner based on mode.
 * Uses discriminated union to enforce type-safe props per mode.
 *
 * Modes:
 * - 'disabled': Shows info banner with custom message
 * - 'pin-required': Shows PIN validation banner with enter PIN button and modal
 * - 'warning': Shows warning banner when order is not confirmed
 * - 'none': Renders nothing
 */
export const ConfirmationBanner: React.FC<ConfirmationBannerProps> = (props) => {
  const {t} = useTranslation()

  switch (props.mode) {
    case 'disabled':
      return (
        <Alert variant="info" className="mt-3">
          {t(props.message, 'Please contact dispatch to confirm delivery')}
        </Alert>
      )

    case 'pin-required':
      return <PinValidationBanner />

    case 'warning':
      return (
        <Alert variant="warning" className="mt-3">
          {t('orderIntake.rmc.steps.shared.orderConfirmation.warningMessage')}
        </Alert>
      )

    case 'none':
      return null
  }
}
